import React from 'react';
import { InputNumber } from 'formik-antd';
import FormControl from '~/components/Form/FormControl';
import { SelectAntd, SelectAntdFormik } from '~/components/Pagination/styles';
import InputCurrency from '~/components/Form/InputCurrency';
import Button from '~/components/Button';
import i18next from 'i18next';
import { FaTrash } from 'react-icons/fa';
import { Typography } from 'antd';
import { formatPrice, parsePrice } from '~/Utils/format';

export const sectorOperationalColumns = (operationals, errors, fluidPermissions, values, setFieldValue) => {
  return [
    {
      title: i18next.t('fields:event.sector.operational.name'),
      dataIndex: 'operational_id',
      key: 'operational_id',
      width: '40%',
      render: (_, record, index) => (
        <FormControl
          field={`sectors.${record.sectorIndex}.sector_operationals.${index}.operational_id`}
          error={errors?.sectors?.[record.sectorIndex]?.sector_operationals?.[index]?.operational_id}
          list
          required
        >
          <SelectAntdFormik
            placeholder="SELECIONE"
            name={`sectors.${record.sectorIndex}.sector_operationals.${index}.operational_id`}
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            onSelect={(value) => {
              const selectedOperational = operationals.find((item) => item.id === value);

              if (selectedOperational) {
                setFieldValue(
                  `sectors.${record.sectorIndex}.sector_operationals.${index}.operational_name`,
                  selectedOperational.name
                );
              }
            }}
            disabled={!fluidPermissions()}
          >
            {operationals?.map((item) => (
              <SelectAntd.Option key={item.id} value={item.id}>
                {item.name}
              </SelectAntd.Option>
            ))}
          </SelectAntdFormik>
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:event.sector.operational.amount'),
      dataIndex: 'amount',
      key: 'amount',
      render: (_, record, index) => (
        <FormControl
          field={`sectors.${record.sectorIndex}.sector_operationals.${index}.amount`}
          error={errors?.sectors?.[record.sectorIndex]?.sector_operationals?.[index]?.amount}
          list
          required
        >
          <InputNumber
            name={`sectors.${record.sectorIndex}.sector_operationals.${index}.amount`}
            onChange={(value) => {
              setFieldValue(`sectors.${record.sectorIndex}.sector_operationals.${index}.amount`, value);
              const currentPrice = values?.sectors?.[record.sectorIndex]?.sector_operationals?.[index]?.price_unit || 0;
              const total = Number(value || 0) * parsePrice(currentPrice);
              setFieldValue(`sectors.${record.sectorIndex}.sector_operationals.${index}.price_total`, total);
            }}
            number
            disabled={!fluidPermissions()}
          />
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:event.sector.operational.priceUnit'),
      dataIndex: 'price_unit',
      key: 'price_unit',
      render: (_, record, index) => (
        <FormControl
          field={`sectors.${record.sectorIndex}.sector_operationals.${index}.price_unit`}
          error={errors?.sectors?.[record.sectorIndex]?.sector_operationals?.[index]?.price_unit}
          list
          required
        >
          <InputCurrency
            name={`sectors.${record.sectorIndex}.sector_operationals.${index}.price_unit`}
            disabled={!fluidPermissions()}
            onChange={(value) => {
              setFieldValue(`sectors.${record.sectorIndex}.sector_operationals.${index}.price_unit`, value);
              const currentAmount = values?.sectors?.[record.sectorIndex]?.sector_operationals?.[index]?.amount || 0;
              const total = Number(currentAmount || 0) * parsePrice(value);
              setFieldValue(`sectors.${record.sectorIndex}.sector_operationals.${index}.price_total`, total);

              if (!record?.invite_price || record?.price_unit === record?.invite_price) {
                setFieldValue(`sectors.${record.sectorIndex}.sector_operationals.${index}.invite_price`, value);
              }
            }}
          />
        </FormControl>
      ),
    },
    {
      title: 'Total',
      dataIndex: 'price_total',
      key: 'price_total',
      render: (_, record) => {
        return <Typography.Text strong>{formatPrice(record.price_total)}</Typography.Text>;
      },
    },
    {
      title: '',
      key: 'action',
      render: (_, record, index) => (
        <Button
          color="danger"
          title="Remover operacional"
          size="small"
          style={{ width: '30px' }}
          onClick={() => record?.remove(index)}
          disabled={!fluidPermissions()}
          icon={<FaTrash />}
        />
      ),
    },
  ];
};
